import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { stranger } from "../characters/Stranger";
import { extras, images } from "./images";
import { V7EmilyPhoneAfter } from "./V7";

export const V7EmilyPhone = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_5, { duration: 1 });
    await mc.setQuestion(new Question({ text: `She left her phone behind again...`, options: { think: true }, key: `v7CheckedEmilyPhone` })
        .option({ title: `Check it`, key: true })
        .option({ title: `Don't check it`, key: false }));


    if (Question.globalAnswers.v7CheckedEmilyPhone) {
        await Phone.showMessagesUI({ name: `DOUCHEBAG`, profileImage: extras.exProfileImage }, async () => {
            Phone.setMessage({ character: stranger.character, text: `Hey! Just making sure that you got home safe and that you've settle in!😘`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Emily?`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `I guess you are just busy unpacking!\nJust send me a message when you are available!🙂`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Good morning! I hope you slept well after the long drive! Have a wonderful day!😘`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `So I was at the grocery store and I bought the cherry candy bar you like so much by mistake!\nYou know I don't like it. So if you are around there is a candy bar here waiting for you!😁`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Good night honey! Sleep tight!😘😘😘`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Emily?`, options: { wait: false } });

            Phone.setMessage({ character: stranger.character, text: `Please answer me...`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Honey, I know we ended up on the wrong foot. But we can make it work.`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `I'm sorry ok? Please answer me. I want to know that you are ok.`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `I've realized by now that you have no intention of answering me...\nI was deluded by the thought that you might come around and come back...\nI'm sorry for everything... If we are not going to talk ever again can we please end it properly?`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `I know the address... Just say the word and I'll drive over ASAP...`, options: { wait: false } });
            Phone.setMessage({ character: stranger.character, text: `Please let me know... I won't bother you ever again if you say no...` });

            let text = `I can pretend to be Emily...`;
            if (Question.globalAnswers.v1EnableNTR) {
                if (mc.properties.joeStatus === "enemy") {
                    if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {

                        Phone.talk({ character: mc.character, text: "I told Emily to give Joey a chance...", options: { wait: true, think: true } });
                        Phone.talk({ character: mc.character, text: "Do I really want to sabotage it before it started...?", options: { wait: true, think: true } });
                    } else {

                        Phone.talk({ character: mc.character, text: "I wonder...", options: { wait: true, think: true } });
                        Phone.talk({ character: mc.character, text, options: { wait: true, think: true } });
                    }

                } else {

                    Phone.talk({ character: mc.character, text: "I wonder...", options: { wait: true, think: true } });
                    Phone.talk({ character: mc.character, text, options: { wait: true, think: true } });
                }


            } else {
                text = `I can pretend to be Emily and finish this one and for all.`;
                Phone.talk({ character: mc.character, text: "I wonder...", options: { wait: true, think: true } });
                Phone.talk({ character: mc.character, text, options: { wait: true, think: true } });
            }




            Phone.talk({ character: mc.character, text: '', options: { wait: false, think: true } });
            await Phone.setQuestion({
                character: mc.character, question: new Question({ text: `I can pretend to be Emily...`, options: { think: true }, key: `v7InvitedEmilysEx` })
                    .option({ title: `Ok, let's meet`, key: "invited", show: Question.globalAnswers.v1EnableNTR })
                    .option({ title: `Don't contact me ever again`, key: "refused" })
                    .option({ title: `<Put the phone back>`, key: "didNothing" })
            });

            if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
                Phone.setMessage({ character: mc.character, text: `Ok, let's meet.` });

            } else if (Question.globalAnswers.v7InvitedEmilysEx === "refused") {
                Phone.setMessage({ character: mc.character, text: `Don't contact me ever again.` });

            } else {

            }


            Phone.closeMessagesUI();
        });

        if (Question.globalAnswers.v7InvitedEmilysEx === "invited" || Question.globalAnswers.v7InvitedEmilysEx === "refused") {
            mc.think(`I've deleted my response just in case...`);
            if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
                mc.think(`Not that it matters... They will talk about it once he arrives anyway...`);

            } else {
                mc.think(`I hope that's the last time she hears from this douche.`);
            }

        } else {
            mc.think(`Wow. this dude is really desperate... Like come on dude, find someone else.`);
        }
    } else {
        if (Game.seenScenarios.includes(`V6EmilysPics`)) {
            mc.think(`I've already taken a peak the other day and saw some private pics of her...`);
            mc.think(`I'll just leave it be this time.`);
        } else {
        }

    }

    return jump(V7EmilyPhoneAfter, "V7EmilyPhoneAfter");
};